module.exports = __webpack_public_path__ + "img/PL08924.bf8ce1fd.png";